
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/archives/[archiveSlug]",
      function () {
        return require("private-next-pages/blog/archives/[archiveSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/archives/[archiveSlug]"])
      });
    }
  